import { useQuery, UseQueryResult } from 'react-query'

import { FetchUserProfileResult } from './types'
import { fetchProfileData } from './services'

export function useProfileQuery(): UseQueryResult<FetchUserProfileResult> {
   return useQuery('userProfile', fetchProfileData)
}
